import Routing from "./Routes/Routing";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { ParentProvider } from "./APIContext/ParentContext";
import { PlayerAccountProvider } from "./APIContext/PlayerAccountContext";
import { BuyPackagesProvider } from "./APIContext/BuyPackagesContext";
import { SessionProvider } from "./APIContext/SessionContext";
import "./App.css";
import { useLogin } from "./APIContext/LoginContext";
// import { useMOU } from "./APIContext/MOUContext";
import ScrollToTop from "./ScrollToTop";

import { NotificationProvider } from "./APIContext/NotificationContext";
import {PreferencesProvider } from "./APIContext/PreferencesContext";
import {ListSportsProvider } from "./APIContext/ListSportsContext";
import { useNavigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {STRIPE_PUBLISHABLE_KEY} from "./Config/Config"
import { useEffect } from "react";
import { PaymentProvider } from "./APIContext/PaymentContext";
import { MOUProvider } from "./APIContext/MOUContext";
import { ForgetPasswordProvider } from "./APIContext/ForgetPasswordContext";
import { BrokerProvider } from "./APIContext/BrokerContext";
import { NewUserContextProvider } from "./APIContext/NewUserContext";


const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
function AppWrapper() {
  const { user , setUser } = useLogin();
  // const { checkMOUStatusForAll, mouData } = useMOU();
  const navigate = useNavigate();
  
// useEffect(() => {
//   const checkUserStatus = async () => {
//     const userLocal = JSON.parse(localStorage.getItem('user'));

//     if (userLocal && userLocal.player_count === 0) {
//       navigate("/add-a-child");
//     } else if (
//       userLocal &&
//       userLocal.is_self_pay === false &&
//       (userLocal.has_preferences === null || userLocal.has_preferences === false)
//     ) {
//       navigate("/preferences");
//     }
//   };

//   checkUserStatus();
// }, []);

  return (
  <NewUserContextProvider>
    <ParentProvider user={user} setUser={setUser}>
      <PreferencesProvider>
        <PlayerAccountProvider>
          <BuyPackagesProvider>
            <SessionProvider>
              <NotificationProvider>
                <ListSportsProvider>
                  <PaymentProvider>
                     <Elements stripe={stripePromise}>
                       <MOUProvider>
                        <ForgetPasswordProvider>
                          <BrokerProvider>
                          <ScrollToTop />
                            <Routing />
                          </BrokerProvider>
                        </ForgetPasswordProvider>
                       </MOUProvider>
                     </Elements>
                  </PaymentProvider>
                </ListSportsProvider>
              </NotificationProvider>
            </SessionProvider>  
          </BuyPackagesProvider>
        </PlayerAccountProvider>
      </PreferencesProvider>
    </ParentProvider>
  </NewUserContextProvider>
  );
}

export default AppWrapper;
